import { FAQ_LIST } from 'App/store/constants';
const initialState = {
  faqs: [],
  errors: {},
  loading: false,
};

// Two endpoints feed into this reducer with different shapes:
//   - public  /faqs/static/<categories>  →  payload.data is an array
//   - admin   /faqs                      →  payload.data is { data, meta }
// Pick the array out of either shape so the screen doesn't break when
// the data source changes.
const extractFaqs = (payload: any): any[] => {
  const inner = payload?.data;
  if (Array.isArray(inner)) return inner;
  if (Array.isArray(inner?.data)) return inner.data;
  return [];
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FAQ_LIST.PENDING:
      return { ...state, faqs: [], loading: true };
    case FAQ_LIST.SUCCESS:
      return { ...state, faqs: extractFaqs(action.payload), loading: false };
    case FAQ_LIST.FAILURE:
      return { ...state, faqs: [], errors: action.payload, loading: false };
    default:
      return state;
  }
};

export default reducer;
